// @ts-expect-error jpgs are untyped modules
import DataStudioHero from 'bender-url!../../../assets/images/data-studio.jpg';
// @ts-expect-error jpgs are untyped modules
import QuotaPathHero from 'bender-url!../../../assets/images/quota-path.jpg';
// @ts-expect-error jpgs are untyped modules
import SnowflakeHero from 'bender-url!../../../assets/images/snowflake.jpg';
// @ts-expect-error jpgs are untyped modules
import BreezeAgentsHero from 'bender-url!../../../assets/images/breeze-agents.jpg';
// @ts-expect-error jpgs are untyped modules
import GeminiConnectorHero from 'bender-url!../../../assets/images/gemini-connector.jpg';
import I18n from 'I18n';
import { useMemo } from 'react';
import { matchPath, useParams, useRouteMatch } from 'react-router-dom';
import { Paths } from '../../constants/paths';
const createHeroItem = (path, title, subtitle, buttonText, buttonUrl, options = {}) => Object.assign({
  path,
  title,
  subtitle,
  buttonText,
  buttonUrl
}, options);
const getHeroItems = () => [createHeroItem(Paths.APPS, I18n.text('marketplaceStorefront.hero.apps.snowflake.title'), I18n.text('marketplaceStorefront.hero.apps.snowflake.subheading'), I18n.text('marketplaceStorefront.hero.apps.snowflake.buttonText'), 'https://ecosystem.hubspot.com/marketplace/listing/snowflake-data-ingestion', {
  imageUrl: SnowflakeHero
}), createHeroItem(Paths.AGENTS, I18n.text('marketplaceStorefront.hero.agents.aiTeammates.title'), I18n.text('marketplaceStorefront.hero.agents.aiTeammates.subheading'), I18n.text('marketplaceStorefront.hero.agents.aiTeammates.buttonText'), 'https://ecosystem.hubspot.com/marketplace/breeze-agents/all', {
  imageUrl: BreezeAgentsHero
}), createHeroItem(Paths.HOME, I18n.text('marketplaceStorefront.hero.home.marketplaceLaunch.title'), I18n.text('marketplaceStorefront.hero.home.marketplaceLaunch.subheading'), I18n.text('marketplaceStorefront.hero.home.marketplaceLaunch.buttonText'), 'https://ecosystem.hubspot.com/marketplace/featured', {
  videoId: 194140177068
}), createHeroItem(Paths.HOME, I18n.text('marketplaceStorefront.hero.home.quotaPath.title'), I18n.text('marketplaceStorefront.hero.home.quotaPath.subheading'), I18n.text('marketplaceStorefront.hero.home.quotaPath.buttonText'), 'https://ecosystem.hubspot.com/marketplace/listing/quotapath', {
  imageUrl: QuotaPathHero
}), createHeroItem(Paths.HOME, I18n.text('marketplaceStorefront.hero.home.dataActivation.title'), I18n.text('marketplaceStorefront.hero.home.dataActivation.subheading'), I18n.text('marketplaceStorefront.hero.home.dataActivation.buttonText'), 'https://ecosystem.hubspot.com/marketplace/featured/data-activation', {
  imageUrl: DataStudioHero
})];
const getAiEssentialsHeroItems = () => [createHeroItem(Paths.FEATURED_COLLECTION, I18n.text('marketplaceStorefront.umbrellaCollections.aiEssentials.hero.anthropicConnector.title'), I18n.text('marketplaceStorefront.umbrellaCollections.aiEssentials.hero.anthropicConnector.subheading'), I18n.text('marketplaceStorefront.umbrellaCollections.aiEssentials.hero.anthropicConnector.buttonText'), 'https://hubspot.com/ai-tools/claude-connector', {
  videoId: 194142541338
}), createHeroItem(Paths.FEATURED_COLLECTION, I18n.text('marketplaceStorefront.umbrellaCollections.aiEssentials.hero.chatgptConnector.title'), I18n.text('marketplaceStorefront.umbrellaCollections.aiEssentials.hero.chatgptConnector.subheading'), I18n.text('marketplaceStorefront.umbrellaCollections.aiEssentials.hero.chatgptConnector.buttonText'), 'https://hubspot.com/ai-tools/openai-connector', {
  videoId: 194140662919
}), createHeroItem(Paths.FEATURED_COLLECTION, I18n.text('marketplaceStorefront.umbrellaCollections.aiEssentials.hero.geminiConnector.title'), I18n.text('marketplaceStorefront.umbrellaCollections.aiEssentials.hero.geminiConnector.subheading'), I18n.text('marketplaceStorefront.umbrellaCollections.aiEssentials.hero.geminiConnector.buttonText'), 'https://docs.google.com/forms/d/e/1FAIpQLSeGn-ehnWJcrIyPMREKA3yJU4Sj1-pApWyahBNnfetXHwZ_mg/viewform', {
  imageUrl: GeminiConnectorHero
})];
const shouldShowAiEssentialsHeros = (collectionSlug, currentPath) => collectionSlug === 'ai-essentials' && !!matchPath(currentPath, {
  path: Paths.FEATURED_COLLECTION,
  exact: true
});
const filterHeroItemsByPath = (items, currentPath) => items.filter(item => matchPath(currentPath, {
  path: item.path,
  exact: true
}));
export function useHeroData() {
  const currentMatch = useRouteMatch();
  const {
    collectionSlug
  } = useParams();
  const heroItems = useMemo(() => {
    if (!(currentMatch !== null && currentMatch !== void 0 && currentMatch.path)) {
      return [];
    }
    const allItems = [...getHeroItems()];
    if (shouldShowAiEssentialsHeros(collectionSlug, currentMatch.path)) {
      allItems.push(...getAiEssentialsHeroItems());
    }
    return filterHeroItemsByPath(allItems, currentMatch.path);
  }, [currentMatch === null || currentMatch === void 0 ? void 0 : currentMatch.path, collectionSlug]);
  return {
    heroItems,
    loading: false,
    error: undefined
  };
}